/// <reference types="leaflet-contextmenu" />
import { type ContextMenuItem, LatLngBounds, type PointTuple } from 'leaflet';
import { defineStore } from 'pinia';
import { useMainStore } from '@/features/common/stores';
import { computed, nextTick, reactive, toRefs, watch } from 'vue';

const defaultState = () => ({
    center: [58.97, 5.7331] as PointTuple,
    zoom: 15,
    userLocation: null as GeolocationCoordinates | null,
    paddingTopLeft: undefined as PointTuple | undefined,
    paddingBottomRight: undefined as PointTuple | undefined,
    grayscale: false
});

const useMapStore = defineStore('mapStore', () => {
    const mainStore = useMainStore();

    const state = reactive({
        ...defaultState(),
        bounds: new LatLngBounds([
            [0, 0],
            [0, 0]
        ]),
        contextmenu: undefined as ContextMenuItem[] | undefined
    });

    const googleMutantOptions = computed(() => ({
        apiKey: mainStore.config.googleMapsConfig.apiKey,
        mapId: mainStore.config.googleMapsConfig.cloudStyleMapId
    }));

    watch(
        () => mainStore.config.googleMapsConfig.center,
        value => {
            const { latitude: lat, longitude: lng } = value;
            state.center = [lat, lng];
        },
        { deep: true, once: true }
    );

    function $reset() {
        nextTick(() => Object.assign(state, defaultState()));
    }

    return {
        ...toRefs(state),
        googleMutantOptions,
        $reset
    };
});

export default useMapStore;
